export default __webpack_public_path__ + "static/media/placeholder2.7f7f8ae3.png";